<div class="single-recap-view--scroll-box">
	<div class="single-recap-view--container">
		<app-recap
			*ngIf="stub"
			[gameStub]="stub"
			[user]="user"></app-recap>
	</div>
</div>
